export const teamInitState = {
    addMember: true,
    membersData: {},
    memberlistloader: false,
    memberSearchData: null,
    loaderRerender: false,
    roleAccessLoader:false,
    callUsageData : {},
    roleAccessList : {},
    saveAndEditData : {},
    sideMenuDtls: {},
    memberRecentChatData: {},
    memberRecentChatLoading:false,
    selectedUserIdRecentChat: null,
    memberChatHistory: {},
    memberChatHistoryLoading:false,
    selectedMemberData:null,
    setPaginationLoader:true,
    chatMediaDownloadData: {},
    profileMediaDownloadData: {},
    downloadingMessagesList:[]
};

export const employeeReducer = (state = teamInitState, action = {}) => {
    switch (action.type) {
        //when page enter all reducer value clear
        case 'TEAM_INITIAL_STAGE': {
            return {
                ...state,
                ...teamInitState
            };
        }
        //all reasult data store here
        case 'GET_EMPLOYEE_LIST_DATA': {
            return {
                ...state,
                membersData: action.MemberData
            };
        }
        case 'GET_CALL_USAGE_LIST_DATA': {
            return {
                ...state,
                callUsageData: action.callUsageData
            };
        }
        case 'EMPLOYEE_RELOAD_LOADER': {
            return {
                ...state,
                loaderRerender: action.loading,
                isFromUpdate:action?.isFromUpdate
            };
        }
        //initial load and search load
        case 'GET_EMPLOYEE_LIST_DATA_LOAD': {
            return {
                ...state,
                memberlistloader: action.memberListLoad,
            };
        }
        // userSearch data will store otherwise null
        case 'SEARCH_EMPLOYEE_DATA': {
            return {
                ...state,
                memberSearchData: action.memberSearch,
            };
        }
        case 'GET_ROLE_ACCESS_DATA': {
            return {
                ...state,
                roleAccessList: action.roleAccessList,
            };
        }case 'GET_ROLE_ACCESS_DATA_LOAD': {
            return {
                ...state,
                roleAccessLoader: action.roleAccessLoader,
            };
        }

        case 'SAVE_AND_EDIT_DATA': {
            return {
                ...state,
                saveAndEditData: action.saveAndEditData,
            };
        }
        case 'SIDEMENU_DETAILS': {
            return {
                ...state,
                sideMenuDtls: action.sideMenuDtls
            };
        }
        case "GET_MEMBER_RECENT_CHAT": {
            const newList = action.memberRecentChatData?.data?.data || [];
            const oldList = state.memberRecentChatData?.data?.data || [];

            let mergedList;

            if (action.reset === true) {
                mergedList = newList;
            } else {
                mergedList = [...oldList, ...newList];
            }

            return {
                ...state,
                memberRecentChatData: {
                    ...state.memberRecentChatData,
                    ...action.memberRecentChatData,
                    data: {
                        ...state.memberRecentChatData?.data,
                        ...action.memberRecentChatData?.data,
                        data: mergedList
                    }
                }
            };
        }
        case 'GET_MEMBER_RECENT_CHAT_DATA_LOAD': {
            return {
                ...state,
                memberRecentChatLoading: action.memberRecentChatLoading,
            };
        }
        case 'SELECTED_MEMBER_USER_ID': {
            return {
                ...state,
                selectedUserIdRecentChat: action.selectedUserId,
            };
        }
        case "GET_MEMBER_CHAT_HISTORY": {
            const newMessages = action.memberChatHistory?.data?.data || [];
            const oldMessages = state.memberChatHistory?.data?.data || [];

            let mergedMessages;

            if (action.reset === true) {
                mergedMessages = newMessages;
            } else {
                mergedMessages = [...oldMessages, ...newMessages];
            }

            let updatedRecentChatData = state.memberRecentChatData;
            if (action.reset === true && newMessages.length > 0 && updatedRecentChatData?.data?.data) {
                const latestMsg = newMessages[0];
                const recentChats = [...updatedRecentChatData.data.data];

                const index = recentChats.findIndex(chat =>
                    (chat.fromUserId === latestMsg.fromUserId && chat.toUserId === latestMsg.toUserId) ||
                    (chat.fromUserId === latestMsg.toUserId && chat.toUserId === latestMsg.fromUserId)
                );

                if (index !== -1) {
                    recentChats[index] = {
                        ...recentChats[index],
                        msgBody: latestMsg.msgBody,
                        createdAt: latestMsg.createdAt,
                        msgId: latestMsg.msgId,
                        message_type: latestMsg.message_type || latestMsg.msgBody?.message_type,
                        recallStatus: latestMsg?.recallStatus
                    };

                    updatedRecentChatData = {
                        ...updatedRecentChatData,
                        data: {
                            ...updatedRecentChatData.data,
                            data: recentChats
                        }
                    };
                }
            }

            return {
                ...state,
                memberRecentChatData: updatedRecentChatData,
                memberChatHistory: {
                    ...state.memberChatHistory,
                    ...action.memberChatHistory,
                    data: {
                        ...state.memberChatHistory?.data,
                        ...action.memberChatHistory?.data,
                        data: mergedMessages
                    }
                }
            };
        }
        case 'GET_MEMBER_CHAT_HISTORY_DATA_LOAD': {
            return {
                ...state,
                memberChatHistoryLoading: action.memberChatHistoryLoading,
            };
        }
        case 'SET_SELECTED_MEMBER_DATA': {
            return {
                ...state,
                selectedMemberData: action.selectedMemberData,
            };
        }
        case 'SET_PAGINATION_LOADER': {
            return {
                ...state,
                setPaginationLoader: action.setPaginationLoader
            };
        }
        case 'RESET_MEMBER_CHAT_HISTORY': {
            return {
                ...state,
                memberChatHistory: {}
            };
        }
        case 'CHAT_MEDIA_DOWNLOAD_DATA': {
            return {
                ...state,
                chatMediaDownloadData: action.chatMediaDownloadData
            };
        }
        case 'PROFILE_MEDIA_DOWNLOAD_DATA': {
            return {
                ...state,
                profileMediaDownloadData: action.profileMediaDownloadData
            };
        }
        case 'RESET_PROFILE_MEDIA_DOWNLOAD_DATA': {
            return {
                ...state,
                profileMediaDownloadData: {}
            };
        }
        case 'CHAT_PARTNER_MEDIA_DOWNLOAD_DATA': {
            return {
                ...state,
                chatPartnerMediaDownloadData: action.chatPartnerMediaDownloadData
            };
        }
        case 'RESET_CHAT_PARTNER_MEDIA_DOWNLOAD_DATA': {
            return {
                ...state,
                chatPartnerMediaDownloadData: {}
            };
        }
        case 'RESET_MEMBER_RECENT_CHAT': {
            return {
                ...state,
                memberRecentChatData: {}
            };
        }
        case 'ADD_DOWNLOADING_MESSAGE': {
            const { msgId } = action;
            const updatedList = state.downloadingMessagesList.includes(msgId)
                ? state.downloadingMessagesList
                : [...state.downloadingMessagesList, msgId];
            return {
                ...state,
                downloadingMessagesList: updatedList
            };
        }
        case 'REMOVE_DOWNLOADING_MESSAGE': {
            const { msgId } = action;
            const updatedList = state.downloadingMessagesList.filter(id => id !== msgId);
            return {
                ...state,
                downloadingMessagesList: updatedList
            };
        }
        default:
            return {
                ...state
            };
    }
};
